export default [
  {
    path: '/modules/financial/contas',
    name: 'contas',
    component: () => import('@/views/modules/financial/contas/ContasList.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Contas',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Cadastros' },
        { text: 'Contas', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/contas/add',
    name: 'conta-form',
    component: () => import('@/views/modules/financial/contas/ContaForm.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Nova Conta',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contas', to: { name: 'contas' } },
        { text: 'Nova Conta', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/contas/edit/:id',
    name: 'conta-edit',
    component: () => import('@/views/modules/financial/contas/ContaForm.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Editar Conta',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contas', to: { name: 'contas' } },
        { text: 'Editar Conta', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/contas/detail/:id',
    name: 'conta-detail',
    component: () => import('@/views/modules/financial/contas/ContaDetail.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Detalhes da Conta',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contas', to: { name: 'contas' } },
        { text: 'Detalhes', active: true },
      ],
    },
  },
]
